module.exports = __webpack_public_path__ + "media/assets/images/flags/de-0667492a1c27be7aae1a4daf3f100f61.svg";